import { Injectable } from '@angular/core';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { TaskListHeader } from 'src/app/models/domain';
import { YPMTASKLISTSRVHeader } from 'src/generated-clients/tasklist';

@Injectable({
  providedIn: 'root',
})
// eslint-disable-next-line @typescript-eslint/padding-line-between-statements
export class TaskListHeaderAdapter implements IAdapter<TaskListHeader, YPMTASKLISTSRVHeader> {
  public adaptToDomain(item: YPMTASKLISTSRVHeader): TaskListHeader {
    return new TaskListHeader({
      taskListType: fallbackString(item.taskListType),
      changeNumber: fallbackString(item.changeNumber),
      taskListGroup: fallbackString(item.taskListGroup),
      groupCounter: fallbackString(item.groupCounter),
      inactive: Boolean(item.inactive),
      counter: fallbackString(item.counter),
      createdBy: fallbackString(item.createdBy),
      usage: fallbackString(item.usage),
      description: fallbackString(item.description),
      changedBy: fallbackString(item.changedBy),
      usageDescription: fallbackString(item.usageDescription),
      plant: fallbackString(item.plant),
      status: fallbackString(item.status),
      changedOn: fallbackDate(item.changedOn),
      createdOn: fallbackDate(item.createdOn),
      validFrom: fallbackDate(item.validFrom),
    });
  }
}
